import React from "react";
import "../assets/styles/components/Error.scss";
import errorImage from "../assets/static/images/error.gif";

const Error = () => (
  <div className="error">
    <img className="error-img" src={errorImage} alt="problem ocurred" />
    <br/>
    <span className="error-text">Sorry a problem has occurred</span>
  </div>
);

export default Error;
